<template>
    <div v-if="!loading">
        <text-form-group
                v-model="data.headline"
                name="headline"
                label="Headline"
                :error="(errors.headline || [])[0]"
        />

        <text-form-group
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
        />

        <div v-for="(statistic, index) in data.statistics"
             style="border: 1px solid black; border-radius: 15px; padding: 15px; margin-bottom: 15px">
            <select-form-group
                    v-model="statistic.driver"
                    name="driver"
                    label="Driver"
                    :error="(errors['statistics.' + index + '.driver'] || [])[0]"
                    :options="statisticOptions"
            />

            <text-form-group
                    v-model="statistic.text"
                    name="text"
                    label="Text"
                    :error="(errors['statistics.' + index + '.text'] || [])[0]"
            />

            <base-form
                    v-if="statistic.driver"
                    v-model="statistic.driver_parameters"
                    :driver="statistic.driver"
                    :errors="getStatisticErrors(index)"
            />

            <button type="button" class="btn btn-link btn-block" @click="removeStatistic(index)">
                <i class="fa fa-minus"/> Remove Statistic
            </button>
        </div>

        <button type="button" class="btn btn-black btn-block" style="margin-bottom: 15px;" @click="addStatistic">
            <i class="fa fa-plus"/> Add Statistic
        </button>
    </div>
</template>

<script>
    import http from '@/http'
    import BaseForm from '@/components/Panels/Administration/MarketingSites/Blocks/StatisticForms/Base'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {BaseForm, SelectFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        data() {
            return {
                statistics: null,

                loading: true
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            },

            statisticOptions() {
                return this.statistics.data.map(statistic => ({value: statistic.id, label: statistic.attributes.name}))
            }
        },

        methods: {
            load() {
                http.get('/api/v2/marketing-site-statistics').then(response => {
                    this.statistics = response.data

                    this.loading = false
                })
            },

            addStatistic() {
                let statistics = this.data.statistics || []

                statistics.push({driver_parameters: {}})

                this.$emit('input', {...this.value, statistics})
            },

            removeStatistic(index) {
                let statistics = this.data.statistics || []

                statistics.splice(index, 1)

                this.$emit('input', {...this.value, statistics})
            },

            getStatisticErrors(index) {
                return Object.entries(this.errors)
                    .filter(entry => entry[0].startsWith('statistics.' + index + '.driver_parameters.'))
                    .reduce((result, entry) => ({
                        ...result,
                        [entry[0].substring(('statistics.' + index + '.driver_parameters.').length)]: entry[1]
                    }), {})
            }
        }
    }
</script>
